export default [
  {
    id: "ways_to_buy",
    type_name: {
      en: "Ways to Buy",
      zh: "购买方式"
    },
    items: [
      {
        id: "buy_now",
        name: {
          en: "Buy now",
          zh: "现价购买"
        }
      },
      {
        id: "bid",
        name: {
          en: "Bid",
          zh: "竞价购买"
        }
      },
      {
        id: "make_offer",
        name: {
          en: "Make Offer",
          zh: "我要竞拍"
        }
      }
    ]
  },
  {
    id: "time",
    type_name: {
      en: "Time",
      zh: "时间"
    },
    items: [
      {
        id: "day_1",
        name: {
          en: "1 day",
          zh: "1 天"
        }
      },
      {
        id: "day_2",
        name: {
          en: "2 days",
          zh: "2 天"
        }
      },
      {
        id: "week_1",
        name: {
          en: "1 week",
          zh: "1 周"
        }
      },
      {
        id: "week_2",
        name: {
          en: "2 week",
          zh: "2 周"
        }
      }
    ]
  },
  {
    id: "price",
    type_name: {
      en: "Price",
      zh: "价格"
    },
    items: [
      {
        id: "0_100_jgn",
        name: {
          en: "0-100 JGN",
          zh: ""
        }
      },
      {
        id: "100_500_jgn",
        name: {
          en: "100-500 JGN",
          zh: ""
        }
      },
      {
        id: "500_1000_jgn",
        name: {
          en: "500-1000 JGN",
          zh: ""
        }
      },
      {
        id: "1000_max_jgn",
        name: {
          en: "1000+ JGN",
          zh: ""
        }
      }
    ]
  },
  {
    id: "store",
    type_name: {
      en: "Store",
      zh: "种类"
    },
    items: [
      {
        id: "a",
        name: {
          en: "A",
          zh: ""
        }
      },
      {
        id: "b",
        name: {
          en: "B",
          zh: ""
        }
      },
      {
        id: "c",
        name: {
          en: "C",
          zh: ""
        }
      }
    ]
  }
];